export default __webpack_public_path__ + "static/media/uterus.7051f617.png";